import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Formik, Field} from 'formik'
import {withTranslation} from 'react-i18next'
import {Flex} from '@rebass/grid'
import {Button, Modal, TextArea} from 'components'
import {updatePayer} from 'payments/actions'
import Images from 'activities/components/NewActivityForm/Details/Images'
import { getActiveType } from 'user'
import { createStructuredSelector } from 'reselect'


const InternalNoteModal = ({ hide, t, updatePayer, activeMember, initialValues }) => {

  const handleSubmit = (values) =>
  new Promise((resolve, reject) => {
      console.log('values', values)
      updatePayer({ values, resolve, reject });
    }).then(hide);
  return (
    <Modal hide={hide} title={`${t('Redigér note')}...`}>
      <Flex flexDirection="column" p={3}>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({ handleSubmit, values, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <Field
                name="internalNote"
                placeholder={`${t('Indtast note')}...`}
                rows="3"
                component={TextArea}
              />
              {activeMember === 2 &&
                <Images
                  setFieldValue={setFieldValue}
                  value={values.images}
                  id={values.id}
                />
              }
              <Button primary small block type="submit" mt={3}>
                {t('Gem')}
              </Button>
            </form>
          )}
        </Formik>
      </Flex>
    </Modal>
  );
};


const mapDispatchToProps = {
  
}



const enhancer = connect(
  createStructuredSelector({
    activeMember: getActiveType
  }),{
    updatePayer: updatePayer.requested,
  }
)


export default withTranslation()(enhancer(InternalNoteModal))
